import { render, staticRenderFns } from "./ComplementaryCareProduct.vue?vue&type=template&id=01d1f676&scoped=true"
import script from "./ComplementaryCareProduct.vue?vue&type=script&lang=js"
export * from "./ComplementaryCareProduct.vue?vue&type=script&lang=js"
import style0 from "./ComplementaryCareProduct.vue?vue&type=style&index=0&id=01d1f676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1f676",
  null
  
)

export default component.exports